var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 567.93 567.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".clsom-1{fill:#343434;stroke:#fff;stroke-miterlimit:10;}.clsom-2{fill:#bababa;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "clsom-1",
    d: "M566.93,283.46A283.47,283.47,0,1,1,0,283.46C0,126.91,126.91,0,283.46,0S566.93,126.91,566.93,283.46Z",
    transform: "translate(0.5 0.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "clsom-2",
    d: "M475.13,492.31a283.46,283.46,0,0,1-390.36-6.68c16.11-94.89,74.28-170,148.56-192.28a159.72,159.72,0,0,1,98.42,2C404.74,320.51,461.07,397,475.13,492.31Z",
    transform: "translate(0.5 0.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "clsom-2",
    cx: 272.97,
    cy: 202.67,
    r: 84.37
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.5a58a632.svg";
export { ForwardRef as ReactComponent };